import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const useDeleteHandler = () => {
  const navigate = useNavigate();

  const handleDelete = useCallback(
    async ({
      deleteApi,
      id,
      refreshListApi,
      redirectPath = null,
    }) => {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won’t be able to undo this action!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete",
      });

      if (!result.isConfirmed) return;

      try {
        const response = await deleteApi(id);

        // ✅ CHECK STATUS PROPERLY
        if (response?.status === 200) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "Deleted successfully",
          });

          refreshListApi?.();
          if (redirectPath) navigate(redirectPath);

        } else {
          // ✅ If status is NOT 200
          await Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Something went wrong",
          });
        }

      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message ||
            "Something went wrong",
        });
      }
    },
    [navigate]
  );

  return { handleDelete };
};
